import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[fiInputMask]',
    standalone: false,
})
export class FiInputMaskDirective {
    @Input('fiInputMask') maskFormat: string = '';
    private readonly specialChars: string[] = [':', '/', '-'];

    constructor(private el: ElementRef) {}

    @HostListener('input') onInputChange() {
        let value = this.el.nativeElement.value.replace(/\D/g, ''); // Remove all non-numeric characters
        let formattedValue = '';
        let valueIndex = 0;

        // Loop through the mask format to create the formatted value
        for (let i = 0; i < this.maskFormat.length; i++) {
            const maskChar = this.maskFormat[i];

            // If the mask character is not a number (i.e., it's a special char like : or /), add it to the formatted value
            if (this.specialChars.includes(maskChar)) {
                formattedValue += maskChar;
            } else {
                // If there's a numeric value to place in the format, add it to the formatted value
                if (value[valueIndex]) {
                    formattedValue += value[valueIndex];
                    valueIndex++;
                } else {
                    break; // Stop formatting if the input is less than the mask
                }
            }
        }

        this.el.nativeElement.value = formattedValue;
    }
}
